import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import { FLEXIBILITY_STATUS_LABELS, FLEXIBILITY_STATUSES } from '@/helpers/flexibility';
import { MyTooltip } from '@/webkit/MyTooltip';
import s from './index.module.scss';

export const LenderLoanCard = ({ loan, onClick }) => {
  const { t } = useTranslation('loans');
  return (
    <div className={s.wrapper} onClick={onClick}>
      <div className={s.amount}>{prettyFloatMoney(loan.amounts?.total_loan_amount)}</div>
      <div className={s.table}>
        <div className={s.thead}>
          <div className={s.thead_col}>Round</div>
          <div className={s.thead_col}>Outstanding date</div>
          <div className={s.thead_col}>FPG option</div>
          <div className={s.thead_col}>Payment Flexibility</div>
        </div>
        <div className={s.tbody}>
          <div className={s.tbody_col}>
            February 2026
          </div>
          <div className={s.tbody_col}>{prettyDate(loan.end_date)}</div>
          <div className={s.tbody_col}>70% cap</div>
          <div className={s.tbody_col}>
            <div className={s.flexibility}>
              {loan.flexibility_info.status === FLEXIBILITY_STATUSES.available ? (
                <>
                  <MyTooltip
                    theme="dark"
                    renderContent={() => (
                      <div className={classnames(s.flexibility_tooltip, 'f-small-regular')}>
                        {t('loan_card.payment_move_tooltip')}
                      </div>
                    )}
                    renderElement={() => (
                      <div className={s.flexibility_status}>
                        {FLEXIBILITY_STATUS_LABELS(t)[loan.flexibility_info.status]}
                      </div>
                    )}
                  />
                  <div className={s.flexibility_dot} />
                  <div className={s.flexibility_amount}>
                    {t('loan_card.amount_fee_per_shift', {
                      amount: prettyFloatMoney(loan.flexibility_info.reschedule_fee_amount),
                    })}
                  </div>
                </>
              ) : (
                FLEXIBILITY_STATUS_LABELS(t)[loan.flexibility_info.status]
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
